import React, { Component } from "react";
import { message, Row, Col, InputNumber, Typography, Card, Input } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import {
  ModalItem,
  Form,
  FormItem,
  ErrorItem,
  ButtonItem,
  SwitchItem,
  InputItem,
} from "../../../../Components/Items";
import { EyeOutlined } from "@ant-design/icons";
import DiagramaConversion, {
  AZUL_BIWO,
  AZUL_BIWO_BG,
  LIMA_BIWO,
  LIMA_BIWO_BG,
} from "../../../../Components/DiagramaConversion";
import TablaEjemplosConversion from "../../../../Components/TablaEjemplosConversion";
const { Text } = Typography;

class ModalEditarRelacion extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    relacion: null,
    mostrarEjemplo: false,
  };

  componentDidMount() {
    if (this.props.relacionId) {
      this.consultarRelacion();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.relacionId !== prevProps.relacionId &&
      this.props.relacionId
    ) {
      this.consultarRelacion();
    }
  }

  consultarRelacion() {
    if (!this.props.relacionId) {
      message.error("No se proporcionó el ID de la relación");
      return;
    }

    this.setState({ loading: true });

    axios
      .post(
        "insumos/obtenerRelacionPorId",
        {
          relacionId: this.props.relacionId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2 && res.data.data) {
          const relacion = res.data.data;
          this.setState({ relacion });

          if (this.formRef.current) {
            // Proveedor/Inventario son la unica fuente de verdad de la
            // conversion. Las relaciones viejas se guardaron con el factor a
            // mano y sin esos dos valores, asi que se siembran con su
            // equivalente (1 unidad del proveedor = factor en inventario) para
            // que el campo quede igual al guardado y de ahi en adelante todo
            // cambio se recalcule.
            const base = this.valoresBaseIniciales(relacion);

            this.formRef.current.setFieldsValue({
              costo: relacion.costo,
              compraMin: relacion.compraMin,
              claveUnidad: this.formatearUnidadProveedor(relacion),
              unidadInsumo: this.formatearUnidadInventario(relacion),
              conversionProveedor: base.conversionProveedor,
              conversionInventario: base.conversionInventario,
              unidadInformativa: relacion?.unidadInformativa,
            });

            this.onChangeValoresConversion();
          }
        } else {
          message.error("No se pudo obtener la información de la relación");
          this.cerrarModal();
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        console.error("Error al consultar la relación:", err);
        message.error("Error al consultar la relación");
        this.cerrarModal();
      });
  }

  cerrarModal(exitoso = false) {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.setState({
      relacion: null,
      mostrarEjemplo: false,
    });

    if (exitoso) {
      this.props.onSuccess();
    } else {
      this.props.onCancel();
    }
  }

  onFinish(values) {
    if (!this.state.relacion) {
      message.error("No se ha cargado la información de la relación");
      return;
    }

    this.setState({ loading: true });

    const datosRelacion = {
      _id: this.state.relacion._id,
      costo: values.costo,
      conversion: this.calcularConversion(
        values.conversionProveedor,
        values.conversionInventario
      ),
      compraMin: values.compraMin,
      conversionAutomatica: true,
      conversionProveedor: values.conversionProveedor,
      conversionInventario: values.conversionInventario,
      unidadInformativa: values.unidadInformativa,
      cambiarCostoInsumo: values.cambiarCostoInsumo || false,
    };

    axios
      .post(
        "insumos/editarRelacionInsumo",
        {
          insumoId: this.state.relacion.insumoId,
          empresaId: this.props.empresaId,
          datosRelacion,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        message.success("Relación editada exitosamente");
        this.cerrarModal(true);
      })
      .catch((err) => {
        this.setState({ loading: false });
        console.error("Error al editar la relación:", err);
        message.error("Error al editar la relación");
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  switchMostrarEjemplo = () => {
    this.setState((prevState) => ({
      mostrarEjemplo: !prevState.mostrarEjemplo,
    }));
  };
  // Factor = lo que se da de alta en inventario por cada unidad que entrega el
  // proveedor. Unico lugar donde se calcula la conversion.
  calcularConversion(conversionProveedor, conversionInventario) {
    const proveedor = Number(conversionProveedor) || 0;
    const inventario = Number(conversionInventario) || 0;

    if (proveedor <= 0) return 0;

    return inventario / proveedor;
  }

  // Valores de Proveedor/Inventario con los que abre el modal: los guardados
  // si existen y, si no, el equivalente del factor que se capturo a mano.
  valoresBaseIniciales(relacion) {
    const conversionProveedor = Number(relacion?.conversionProveedor) || 0;
    const conversionInventario = Number(relacion?.conversionInventario) || 0;

    if (conversionProveedor > 0 && conversionInventario > 0) {
      return { conversionProveedor, conversionInventario };
    }

    const conversion = Number(relacion?.conversion) || 0;

    if (conversion > 0) {
      return { conversionProveedor: 1, conversionInventario: conversion };
    }

    return { conversionProveedor: 0, conversionInventario: 0 };
  }

  onChangeValoresConversion = () => {
    const form = this.formRef.current;
    if (!form) return;

    form.setFieldsValue({
      conversion: this.calcularConversion(
        form.getFieldValue("conversionProveedor"),
        form.getFieldValue("conversionInventario")
      ),
    });
  };

  formatearUnidadInventario(relacion) {
    if (!relacion) return "";
    const clave = relacion.unidadSatInsumo || "";
    const nombre = relacion.nombreUnidadInventario || "";
    return clave && nombre ? `${clave} - ${nombre}` : clave || nombre;
  }
  formatearUnidadProveedor(relacion) {
    if (!relacion) return "";
    const clave = relacion.claveUnidad || "";
    const nombre = relacion.nombreUnidadProveedor || "";
    return clave && nombre ? `${clave} - ${nombre}` : clave || nombre;
  }

  renderTablaEjemplo = () => <TablaEjemplosConversion />;

  // Siempre visible (no depende de abrir la calculadora manual): usa los datos
  // reales de conversionProveedor/conversionInventario si ya se capturaron, y
  // si no, arma un ejemplo genérico a partir del factor final (igual que
  // AyudaConversion en las pantallas de solo lectura).
  renderDiagramaEnVivo = () => {
    return (
      <FormItem
        shouldUpdate={(prev, curr) =>
          prev.conversion !== curr.conversion ||
          prev.conversionProveedor !== curr.conversionProveedor ||
          prev.conversionInventario !== curr.conversionInventario ||
          prev.claveUnidad !== curr.claveUnidad ||
          prev.unidadInsumo !== curr.unidadInsumo
        }
        noStyle
      >
        {({ getFieldValue }) => {
          const conversion = parseFloat(getFieldValue("conversion"));
          if (isNaN(conversion)) return null;

          const conversionProveedor = getFieldValue("conversionProveedor") || 0;
          const conversionInventario = getFieldValue("conversionInventario") || 0;
          const claveUnidad = getFieldValue("claveUnidad") || "unidad de compra";
          const unidadInsumo = getFieldValue("unidadInsumo") || "unidad de inventario";

          const tieneDatosBase = conversionProveedor > 0 && conversionInventario > 0;
          const proveedorGenerico =
            conversion >= 1 || conversion <= 0 ? 1 : Math.round((1 / conversion) * 100) / 100;
          const inventarioGenerico = conversion >= 1 || conversion <= 0 ? conversion : 1;

          return (
            <Card
              size="small"
              style={{ marginBottom: 16, backgroundColor: "#fafafa", borderColor: "#d9d9d9" }}
            >
              <Text
                strong
                style={{ color: AZUL_BIWO, fontSize: 13, display: "block", marginBottom: 8 }}
              >
                Así se ve tu conversión
              </Text>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <DiagramaConversion
                  cajaA={{
                    titulo: "El proveedor entrega",
                    cantidad: tieneDatosBase ? conversionProveedor : proveedorGenerico,
                    unidad: claveUnidad,
                    color: AZUL_BIWO,
                    fondo: AZUL_BIWO_BG,
                  }}
                  cajaB={{
                    titulo: "Das de alta en inventario",
                    cantidad: tieneDatosBase ? conversionInventario : inventarioGenerico,
                    unidad: unidadInsumo,
                    color: LIMA_BIWO,
                    fondo: LIMA_BIWO_BG,
                  }}
                  factorTexto={
                    <>
                      Factor de conversión: <strong>{conversion.toFixed(4)}</strong>
                    </>
                  }
                />
              </div>
            </Card>
          );
        }}
      </FormItem>
    );
  };

  renderCalculadora = () => {
    return (
      <>
        <Card
          size="small"
          style={{
            marginBottom: 16,
            backgroundColor: "#e6f7ff",
            borderColor: "#91d5ff",
          }}
        >
          <div style={{ marginBottom: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Text strong style={{ color: "#1890ff", fontSize: 14 }}>
                Cálculo de la conversión
              </Text>
              <EyeOutlined
                onClick={this.switchMostrarEjemplo}
                style={{
                  cursor: "pointer",
                  fontSize: 16,
                  color: this.state.mostrarEjemplo ? "#1890ff" : "#91d5ff",
                  transition: "color 0.3s",
                }}
                title="Ver ejemplos"
              />
            </div>
            <br />
            <Text type="secondary" style={{ fontSize: 12 }}>
              Ingrese los valores con los que recibe el insumo de su proveedor y
              la cantidad en la que usted da de alta en su inventario. Con estos
              dos datos se calcula la conversión.
            </Text>
          </div>

          <Row gutter={16}>
            <Col span={12}>
              <div
                style={{
                  padding: 12,
                  backgroundColor: "white",
                  borderRadius: 4,
                  border: "1px solid #d9d9d9",
                }}
              >
                <Text strong style={{ display: "block", marginBottom: 8 }}>
                  Proveedor
                </Text>
                <Input.Group compact>
                  <FormItem
                    name="conversionProveedor"
                    label="Cantidad del proveedor"
                    gt={0}
                    required
                    noStyle
                  >
                    <InputNumber
                      className="input-number-sin-flechas"
                      min={0}
                      style={{ width: "30%" }}
                      placeholder="Cantidad"
                      onChange={this.onChangeValoresConversion}
                    />
                  </FormItem>
                  <Input
                    value={this.formatearUnidadProveedor(this.state.relacion)}
                    disabled
                    style={{
                      width: "70%",
                      backgroundColor: "#f5f5f5",
                      textAlign: "center",
                    }}
                  />
                </Input.Group>
              </div>
            </Col>

            <Col span={12}>
              <div
                style={{
                  padding: 12,
                  backgroundColor: "white",
                  borderRadius: 4,
                  border: "1px solid #d9d9d9",
                }}
              >
                <Text strong style={{ display: "block", marginBottom: 8 }}>
                  Inventario
                </Text>
                <Input.Group compact>
                  <FormItem
                    name="conversionInventario"
                    label="Cantidad de inventario"
                    gt={0}
                    required
                    noStyle
                  >
                    <InputNumber
                      className="input-number-sin-flechas"
                      style={{ width: "30%" }}
                      min={0}
                      placeholder="Cantidad"
                      onChange={this.onChangeValoresConversion}
                    />
                  </FormItem>
                  <Input
                    value={this.formatearUnidadInventario(this.state.relacion)}
                    placeholder="Unidad"
                    disabled
                    style={{
                      width: "70%",
                      backgroundColor: "#f5f5f5",
                      textAlign: "center",
                    }}
                  />
                </Input.Group>
              </div>
            </Col>
          </Row>
        </Card>
      </>
    );
  };
  render() {
    const { mostrarEjemplo } = this.state;
    return (
      <ModalItem
        title="Editar Relación de Proveedor"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.cerrarModal()}
        paddingTop
        width={600}
      >
        <Form
          ref={this.formRef}
          name="form_editar_relacion"
          layout="vertical"
          bottom={
            <div style={{ display: "flex", justifyContent: "right" }}>
              <ButtonItem
                type="primary"
                onClick={() => this.cerrarModal()}
                rojo
                style={{ marginRight: 8 }}
              >
                Cancelar
              </ButtonItem>
              <ButtonItem
                type="primary"
                htmlType="submit"
                disabled={!this.state.relacion}
              >
                Guardar
              </ButtonItem>
            </div>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <Row>
            <Col span={24}>
              <FormItem
                label="Cambiar Costo Insumo"
                name="cambiarCostoInsumo"
                margin
                valuePropName="checked"
              >
                <SwitchItem />
              </FormItem>
              <FormItem
                name="costo"
                label="Costo"
                margin
                required
              >
                <InputNumber
                  className="input-number-sin-flechas"
                  style={{ width: "100%" }}
                  formatter={(value) =>
                    `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                  precision={2}
                  min={0}
                  placeholder="Costo"
                />
              </FormItem>
              {this.renderDiagramaEnVivo()}
              {this.renderCalculadora()}
              {mostrarEjemplo && this.renderTablaEjemplo()}
              <FormItem
                name="conversion"
                label="Conversión"
                margin
              >
                <InputNumber
                  className="input-number-sin-flechas"
                  style={{ width: "100%" }}
                  min={0}
                  placeholder="Conversión"
                  disabled
                  precision={4}
                />
              </FormItem>

              <FormItem name="compraMin" label="Compra Mínima" margin>
                <InputNumber
                  className="input-number-sin-flechas"
                  style={{ width: "100%" }}
                  min={0}
                  placeholder="Compra Mínima"
                />
              </FormItem>

              {/* <FormItem name="claveUnidad" label="Unidad Proveedor" margin>
                <InputItem placeholder="Unidad Proveedor" />
              </FormItem> */}
              <FormItem name="unidadInformativa" label="Unidad Proveedor" margin>
                <InputItem placeholder="Unidad Proveedor" />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ModalEditarRelacion);
